import { useStrategiesStore } from '@/store/perfect-strategies';
import { useWeb3Store } from '@/web3-server';
export function updateEarnedBlid() {
    const strategiesStore = useStrategiesStore();
    const web3Store = useWeb3Store();
    const clearTimer = () => {
        if (strategiesStore.timerUpdateEarnedBLID) {
            clearInterval(strategiesStore.timerUpdateEarnedBLID);
            strategiesStore.timerUpdateEarnedBLID = null;
        }
    };
    clearTimer();
    strategiesStore.timerUpdateEarnedBLID = setInterval(() => {
        if (strategiesStore.listOfStrategiesWithDepositAndWithoutStorageContract.length) {
            strategiesStore.listOfStrategiesWithDepositAndWithoutStorageContract.forEach((strategy) => {
                const promise = strategiesStore.currentUserDataInit(strategy);
                if (promise) {
                    promise.then((response) => {
                        if (response) {
                            if (!response.isDeposit && strategiesStore.timerUpdateEarnedBLID) {
                                clearTimer();
                                updateEarnedBlid();
                            }
                        }
                    });
                }
            });
        }
        if (strategiesStore.listOfStorageStrategiesWithBoosting.length) {
            strategiesStore.listOfStorageStrategiesWithBoosting.forEach((strategy) => {
                const earnedIncomePromise = web3Store.getEarnedIncomeFromBoosting(strategy.contract, strategy.vault);
                earnedIncomePromise.then((response) => {
                    strategiesStore.updateEarnedIncomeWithPercent(response.earnedBLID, response.earnedUSD, response.percentageYield, strategy);
                });
            });
        }
        if (!strategiesStore.listOfStrategiesWithDepositAndWithoutStorageContract.length &&
            !strategiesStore.listOfStorageStrategiesWithBoosting.length) {
            clearTimer();
        }
    }, 10000);
}
